import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcn/components/ui/tooltip";
import { Equal, EqualNot } from "lucide-react";
import React from "react";

type SearchBoxFilterInverseCheckboxProps = {
  inverseActive: boolean;
  disabled?: boolean;
  onChange: () => void;
};

const SearchBoxFilterInverseCheckbox: React.FC<
  SearchBoxFilterInverseCheckboxProps
> = ({ inverseActive, disabled, onChange }) => {
  return (
    <TooltipProvider>
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
          {inverseActive ? (
            <EqualNot
              className={`cursor-pointer md:hover:text-red-400 text-red-600`}
              onClick={() => {
                onChange();
              }}
            />
          ) : (
            <Equal
              className={`cursor-pointer md:hover:text-red-400 text-gray-600 ${disabled ? "invisible" : ""}`}
              onClick={() => {
                if (!disabled) {
                  onChange();
                }
              }}
            />
          )}
        </TooltipTrigger>
        <TooltipContent side="left" className="mr-3">
          {inverseActive ? "Value does not equal (inverse)" : "Value equals"}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default SearchBoxFilterInverseCheckbox;
